import { Unlock as UnlockIcon } from "lucide-react";
import { Link } from "react-router";

export const BookDemo = ({
    title, 
    description = "Get real-time insights, smarter load planning, and data-driven dispatching!",
    buttonText = "Book a demo",
    linkTo = "https://cargominds.ai/schedule-a-demo/"
}) => {
    return (
        <div className="flex items-center justify-center w-full relative z-20">
            <div className="absolute -top-10 left-0 w-full h-10 pointer-events-none bg-gradient-to-b from-transparent to-cm-p-surface"></div>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-16 bg-cm-p-surface rounded-lg px-6 pt-8 pb-12 w-full h-[143px]">
                <div className="flex items-center gap-4">
                    <UnlockIcon className="w-8 h-8 text-[#8FE6BC] flex-shrink-0" />
                    <div className="text-center sm:text-left">
                        <h3 className="text-lg font-semibold text-[#343735] mb-1">
                            {title}
                        </h3>
                        <p className="text-sm text-[#343735]">
                            {description}
                        </p>
                    </div>
                </div>
                <Link
                    to={linkTo}
                    target="_blank"
                    className={"bg-[#8FE6BC] text-[#343735] px-6 py-2 rounded-lg font-medium hover:bg-[#7DD4A8] transition-colors whitespace-nowrap w-full sm:w-auto text-center text-[18px]"}
                >
                    {buttonText}
                </Link>
            </div>
        </div>
    );
};
